import { useEditDashboardDraft } from '@/features/Dashboard/context/EditDashboardDraft';
import { getTabContent } from '@/features/Dashboard/lib/transformers';
import { DashboardTab, MarketApps } from '@/features/Dashboard/types';
import { useDashboard } from '@/hooks/api/dashboard';

export const useCurrentDashboardConfig = (): DashboardTab | undefined => {
  const { initialDashboardName } = useEditDashboardDraft();
  const { data: allDashboardsConfig } = useDashboard();
  return allDashboardsConfig?.[initialDashboardName];
};

// Helper hook to get MarketApps for a specific tab (for backward compatibility)
export const useCurrentDashboardTabConfig = (tabName?: string): MarketApps | undefined => {
  const dashboardTabs = useCurrentDashboardConfig();
  if (!dashboardTabs) return undefined;

  // If no tabName provided, return first tab
  if (!tabName) {
    const firstTabName = Object.keys(dashboardTabs)[0];
    if (!firstTabName) return undefined;
    const tabValue = dashboardTabs[firstTabName];
    return getTabContent(tabValue);
  }

  const tabValue = dashboardTabs[tabName];
  return tabValue ? getTabContent(tabValue) : undefined;
};
